/* eslint-disable no-unused-vars */
/* eslint-disable camelcase */
/* eslint-disable no-underscore-dangle */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Col, Row, ControlLabel, FormGroup, Glyphicon, OverlayTrigger, Tooltip, Button, Modal } from 'react-bootstrap';
import { Form, Errors, Control, actions } from 'react-redux-form';
import moment from 'moment';
import { Link } from 'react-router-dom';
import Viewer from 'react-viewer';
import 'react-viewer/dist/index.css';
import RequiredDatepicker from '../../../common/form/elements/required-datepicker';
import ArrowButton from '../../../common/button-arrow';
import RequiredInput from '../../../common/form/elements/required-input';
import Select from '../../../common/form/elements/select';
import FileUpload from '../../../common/form/elements/file-upload';
import RemoveSubmissionDialog from '../../submissions/remove-submission-dialog';
import DeclineSubmissionDialog from '../../submissions/decline-submission-dialog';
import SearchableSelect from '../../../common/form/elements/searchable-select';
import TextInput from '../../../common/form/elements/text-input';
import {
  removeSubmission,
  getOutletName,
  internalEnquirySubmission,
  repEnquirySubmission,
  itukEnquirySubmission,
  auditorValidateSubmission,
  checkReceiptIdUniqueness
} from '../../../../actions/submissions';
import AuditAmount from './audit-amount';
import { history } from '../../../../store';

import './styles.css';

const statusOptions = [
  {
    label: 'Yes',
    value: 'APPROVED',
  },
  {
    label: 'No',
    value: 'DECLINED',
  }
];

const declineCommentOptions = [
  {
    label: 'Barcode submitted by owner',
    value: 'BARCODE_SUBMITTED',
    description: 'Barcode submissions have to be submitted by a rep - please request your rep to submit this claim again.'
  },
  {
    label: 'Barcodes not converted correctly',
    value: 'BARCODE_NOT_CONVERTED',
    description: 'The pack sales provided have not been converted correctly from the evidence uploaded.' +
      ' Cigarettes and Blu Bar should be multiplied by 10 and Hand Rolling Tobacco by 5.' +
      ' Please resubmit your claim with the correct packs.'
  },
  {
    label: 'Store does not match evidence',
    value: 'STORE_MATCH_EVIDENCE',
    description: ' The evidence provided shows a different or no store to the one selected - ' +
      ' Please resubmit your claim ensuring the store is visible and matches across the submission and the evidence.'
  },
  {
    label: 'Wrong evidence type selected/uploaded',
    value: 'WRONG_EVIDENCE_TYPE',
    description: 'The evidence type provided does not match the evidence type submitted.' +
      ' Please resubmit your claim with the correct evidence type.'
  },
  {
    label: 'Invalid Image',
    value: 'IMAGE_NOT_SHOW_THE_QTY',
    description: 'The image provided does not show the quantity that is being claimed for the product selected -' +
      ' please resubmit your claim with the supporting evidence or amended quantities.'
  },
  {
    label: 'Duplicate submission',
    value: 'DUPLICATE_SUBMISSION',
    description: 'The image provided has already been used on a claim that has been or is being processed.'
  },
  {
    label: 'Image unreadable',
    value: 'IMAGE_BLURRY',
    description: 'The images provided are unreadable therefore we are not able to identify the products that are being claimed.' +
      ' Please resubmit your claim ensuring the images are clear, you can upload multiple images per.'
  }
];

class AdminSubmissionForm extends Component {
  state = {
    removable: null,
    outletCode: '',
    decline_confirm_dialog: false,
    postcodeplan_audit_amount_warning: false,
    postcodeplan_audit_amount_disable_validate: false,
    incentive_audit_amount_warning: false,
    disable_validate: false,
    receipt_id_uniqueness_warning: false,
    disable_buttons: false
  };

  componentDidUpdate(prevProps) {
    const { formData, dispatch } = this.props;

    if (formData.postcodeplan_objectives_id !== prevProps.formData.postcodeplan_objectives_id) {
      dispatch(actions.resetValidity('deep.admin_submission.incentive_id'));
      dispatch(actions.resetValidity('deep.admin_submission.proof_type'));
    }
  }

  handleOutletCodeChange = (customerNumber) => {
    const { dispatch } = this.props;

    dispatch(getOutletName(customerNumber));
  };

  resetPopup() {
    this.setState({ removable: null, decline_confirm_dialog: false });
  }

  handleRemove(id) {
    this.setState({ removable: id });
  }

  handleConfirmRemove(result) {
    const { dispatch } = this.props;
    const { removable } = this.state;

    if (result && removable) {
      dispatch(removeSubmission(removable))
        .then(() => {
          this.resetPopup();
          history.push('/admin/submissions');
        });
    } else {
      this.resetPopup();
    }
  }

  handleConfirmDecline(result) {
    const { onDecline } = this.props;
    this.setState({ disable_buttons: true });
    if (result) {
      onDecline();
    }
    this.resetPopup();
  }

  handleFileUpload = (file) => {
    const { dispatch } = this.props;

    dispatch(actions.push('deep.admin_submission.proof_of_purchases_attributes', {
      [Date.now()]: { persisted: false, proof_of_purchase: file }
    }));
  };

  removeFile(id, file) {
    const { formData, dispatch } = this.props;
    const index = formData.proof_of_purchases_attributes.map(object => Object.keys(object)[0]).indexOf(id);

    if (file.persisted !== false) {
      dispatch(actions.push('deep.admin_submission.proof_of_purchases_attributes', {
        [id]: {
          id: file.id,
          _destroy: true
        }
      }));
    } else {
      dispatch(actions.remove('deep.admin_submission.proof_of_purchases_attributes', index));
    }
  }

  handleDeclineReasonSelectChange = (event) => {
    const { model, dispatch } = this.props;
    const declineReason = declineCommentOptions.find(declineComment => declineComment.value === event);

    dispatch(actions.change(
      `${model}.savi_comment`,
      `${declineReason.label} - ${declineReason.description}`
    ));
  };

  handleInternalEnquiryClick = () => {
    if (this.state.disable_buttons) {
      return;
    }
    const {
      model, submissionId, formData, dispatch
    } = this.props;
    this.setState({ disable_buttons: true });
    dispatch(actions.submitFields(model, internalEnquirySubmission(submissionId, formData)));
  };

  handleRepEnquiryClick = () => {
    if (this.state.disable_buttons) {
      return;
    }
    const {
      model, submissionId, formData, dispatch
    } = this.props;
    this.setState({ disable_buttons: true });
    dispatch(actions.submitFields(model, repEnquirySubmission(submissionId, formData)));
  };

  handleITUKEnquiryClick = () => {
    if (this.state.disable_buttons) {
      return;
    }
    const {
      model, submissionId, formData, dispatch
    } = this.props;
    this.setState({ disable_buttons: true });
    dispatch(actions.submitFields(model, itukEnquirySubmission(submissionId, formData)));
  };

  handleValidateClick = () => {
    if (this.state.disable_buttons) {
      return;
    }
    const {
      model, submissionId, formData, dispatch
    } = this.props;
    this.setState({ disable_buttons: true });
    dispatch(actions.submitFields(model, auditorValidateSubmission(submissionId, formData)));
  };

  incentiveAuditAmount = () => {
    const { target, formData } = this.props;
    if (!!target && target < formData.audit_amount) {
      this.setState({ incentive_audit_amount_warning: true });
    }
  };

  postcodeplanAuditAmounts = () => {
    const sum = this.props.formData.brand_audit_amounts.map(brand_audit_amount => Number(brand_audit_amount.value)).reduce((a, b) => a + b);
    if (sum > 4999 && sum < 10000) {
      this.setState({ postcodeplan_audit_amount_warning: true });
    }
    if (sum >= 10000) {
      this.setState({ postcodeplan_audit_amount_disable_validate: true, disable_validate: true });
    } else {
      this.setState({ disable_validate: false });
    }
  };

  checkReceiptIdUniqueness = () => {
    const { submissionId, formData: { receipt_id } } = this.props;

    checkReceiptIdUniqueness(submissionId, receipt_id)
      .then((response) => {
        this.setState({ receipt_id_uniqueness_warning: !response });
      })
      .catch(() => this.setState({ receipt_id_uniqueness_warning: false }));
  }

  closePopup = () => {
    this.setState({
      postcodeplan_audit_amount_warning: false,
      postcodeplan_audit_amount_disable_validate: false,
      incentive_audit_amount_warning: false,
      receipt_id_uniqueness_warning: false
    });
  };

  haveAuditAmounts = () => {
    const {
      incentive_id, audit_amount, postcodeplan_objectives_id, brand_audit_amounts
    } = this.props.formData;

    if (!!incentive_id && !!audit_amount) {
      return true;
    }
    if (!!postcodeplan_objectives_id && brand_audit_amounts) {
      const values = brand_audit_amounts.map(amount => amount.value);
      return (values.indexOf(null) === -1 && values.indexOf('') === -1);
    }
    return false;
  }

  render() {
    const {
      formData, formValid, model, onSubmit, onValidate, onDecline, meta, submissionId, editable, isAudit
    } = this.props;
    const {
      postcodeplan_audit_amount_warning,
      postcodeplan_audit_amount_disable_validate,
      incentive_audit_amount_warning,
      disable_validate,
      receipt_id_uniqueness_warning,
      disable_buttons
    } = this.state;
    const {
      type, status, incentive_id, postcodeplan_objectives_id, audit_completed,
      brand_number_of_packs_solds: number_of_packs_solds, brand_audit_amounts: audit_amounts,
      category_number_of_packs_solds, category_audit_amounts, outlet_wse_band, last_claim_validated_date
    } = formData;
    const hasIncentiveId = !!incentive_id;
    const hasPostcodeplanObjectivesId = !!postcodeplan_objectives_id;
    const isValidateDisabled = status !== 'PRE-VALIDATED' && status !== 'QUERIED' && status !== 'DECLINED' && status !== 'INQUIRED';
    const isDeclineDisabled = status !== 'PRE-VALIDATED' && status !== 'QUERIED' && status !== 'INQUIRED';
    const isDeclined = status === 'DECLINED';
    const packsSoldIsDisabled = (hasPostcodeplanObjectivesId &&
       (!status || ['PENDING', 'APPROVED', 'DECLINED', 'VALIDATED', 'PRE-VALIDATED', 'QUERIED', 'INQUIRED'].includes(status))
    );
    const packSoldsZeroAllowed = number_of_packs_solds ? number_of_packs_solds.length > 1 : false;
    const popup =
      postcodeplan_audit_amount_warning ||
      postcodeplan_audit_amount_disable_validate ||
      incentive_audit_amount_warning ||
      receipt_id_uniqueness_warning;

    if (!meta.outlets) {
      return null;
    }

    const { removable } = this.state;
    let fileList = Object.assign({}, ...formData.proof_of_purchases_attributes);
    const imageList = Object.values(fileList)
      .map(original => ({
        src: original.href,
        alt: original.name
      }));
    const path = isAudit ? 'audit/submissions/' : 'submissions/';

    fileList = Object.entries(fileList)
      .filter(([index, file]) => file && file._destroy !== true)
      .map(([index, file]) => {
        const link = file.href ? <Link to={file.href} target='_blank'>{file.name}</Link> : file.name;
        const possible_duplicates = file['possible-duplicates'] ? file['possible-duplicates'].map((possible_duplicate, num) => (
          <span key={possible_duplicate}>
            {num === 0 && <span>&nbsp;Possible duplicate(s):</span>}
            &nbsp;<Link target="_blank" to={`/admin/${path}${possible_duplicate}`}>{possible_duplicate}</Link>
          </span>
        )) : false;

        return (
          <div key={file.id || file.lastModified} style={{ paddingBottom: '5px' }}>
            {!isAudit ? (
              <Glyphicon
                glyph='remove'
                style={{ color: 'red', marginRight: '5px', cursor: 'pointer' }}
                onClick={() => this.removeFile(index, file)}
              />
              ) : null
            }
            {file.persisted === false ? file.proof_of_purchase.name : link }
            {possible_duplicates && possible_duplicates}
          </div>
        );
      });

    return (
      <div className='mg-bottom-60 mg-top-10'>
        <div className='container-fluid'>
          <Form model={model} onSubmit={onSubmit}>
            {isAudit && (
              <Col lg={5}>
                <Row id={'image-view-row'}>
                  <h4>Proof of purchase</h4>
                  <div style={{marginBottom: '20px'}}>{fileList}</div>
                  <div id={'image-view-container'}>
                    <Viewer
                      visible
                      onClose={() => { this.setState({ visible: false }); } }
                      images={imageList}
                      container={document.getElementById('image-view-container')}
                      noClose
                      scalable={false}
                      downloadable={false}
                      noImgDetails
                      zoomSpeed={0.1}
                    />
                  </div>
                </Row>
              </Col>
            )}
            <Col {...(isAudit && { lg: 7 })}>
              <fieldset disabled={!editable}>
                {!editable && !isAudit && (
                  <Row>
                    <h1>
                      This submission has been audited and can no longer be edited
                    </h1>
                  </Row>
                )}
                <Row>
                  <Col md={6}>
                    <span className="text-bold">Status: </span>
                    {type === 'NGP' && status === 'APPROVED' ? 'VALIDATED' : status || 'PENDING'}
                  </Col>
                  {hasPostcodeplanObjectivesId && !isAudit && (
                    <Col className="ta-right" md={6}>
                      <Button
                        className="red-ghost-btn"
                        onClick={onValidate}
                        disabled={isValidateDisabled || disable_buttons}
                      >
                        Validate
                      </Button>
                      <Button
                        className="red-ghost-btn"
                        onClick={onDecline}
                        disabled={isDeclineDisabled || disable_buttons}
                      >
                        Decline
                      </Button>
                    </Col>
                  )}
                </Row>
                <Row>
                  <Col md={6}>
                    <span className="text-bold">Type: </span>
                    {type}
                  </Col>
                </Row>
                <Row>
                  <Col md={6}>
                    <span className="text-bold">Tier Band: </span>
                    {outlet_wse_band}
                  </Col>
                </Row>
                {last_claim_validated_date && (
                  <Row>
                    <Col md={6}>
                      <span className="text-bold">Last claim validated date: </span>
                      {moment(last_claim_validated_date).format('YYYY-MM-DD')}
                    </Col>
                  </Row>
                )}
                <Row>
                  <Col md={12}>
                    <Errors model={model} onSubmit={onSubmit} />
                  </Col>
                </Row>
                <br />
                <Col {...(isAudit && { lg: 6 })}>
                  <Row>
                    <Col md={12}>
                      <RequiredInput
                        label='Outlet name'
                        model='.outlet_name'
                        disabled
                      />
                    </Col>
                  </Row>
                  {hasIncentiveId && (
                    <Row>
                      <Col md={12}>
                        <Select
                          label='Incentive Name'
                          model='.incentive_id'
                          values={meta.incentives}
                          disabled
                          required={!hasPostcodeplanObjectivesId}
                        />
                      </Col>
                    </Row>
                  )}
                  {hasPostcodeplanObjectivesId && (
                    <Row>
                      <Col md={12}>
                        <Select
                          label='Postcodeplan Objective'
                          model='.postcodeplan_objectives_id'
                          values={meta.postcodeplan_objectives}
                          disabled
                        />
                      </Col>
                    </Row>
                  )}
                </Col>
                <Col {...(isAudit && { lg: 6 })}>
                  <Row>
                    {isAudit && (
                      <Col md={6}>
                        <RequiredInput
                          label='User Type'
                          model='.user_group_name'
                          disabled
                        />
                      </Col>
                    )}
                    <Col md={isAudit ? 6 : 12}>
                      <RequiredInput
                        label='Proof type'
                        model='.proof_type'
                        disabled
                      />
                    </Col>
                  </Row>
                  <Row>
                    <Col md={12}>
                      <RequiredInput
                        label='Submission ID'
                        value={this.props.id}
                        model='.id'
                        disabled
                      />
                    </Col>
                  </Row>
                </Col>
                <Row>
                  <Col md={12}>
                    <SearchableSelect
                      label='Store'
                      model='deep.admin_submission.outlet_code'
                      options={meta.outlets.map(outlet => ({
                        value: outlet.customer_number,
                        label: `${outlet.customer_number} - ${outlet.name}`
                      }))}
                      value={formData.outlet_code}
                      onChange={this.handleOutletCodeChange}
                      placeholder='Select Outlet'
                      disabled
                    />
                  </Col>
                </Row>
                {isAudit && (
                  <Row>
                    <Col md={12}>
                      <TextInput
                        onBlur={this.checkReceiptIdUniqueness.bind(this)}
                        label='Receipt ID'
                        model='.receipt_id'
                        disabled={isDeclined}
                      />
                    </Col>
                  </Row>
                )}
                {isAudit && (
                  <Row>
                    <Col md={12}>
                      <RequiredDatepicker
                        model='.purchase_date'
                        controlId="purchase_date"
                        dateFormat="DD/MM/YYYY"
                        label="Purchase date"
                        value={formData.purchase_date}
                        required={false}
                      />
                    </Col>
                  </Row>
                )}
                <Row>
                  <Col md={12}>
                    {!isAudit && (
                      <OverlayTrigger
                        placement='top'
                        overlay={
                          (
                            <Tooltip id='tooltip'>
                              Please ensure you provide the number of outers that you have purchased and not the number of packs
                              you have purchased
                            </Tooltip>)}
                      >
                        <Glyphicon
                          glyph='question-sign'
                          style={{
                            color: '#ab1738',
                            cursor: 'pointer',
                            fontSize: '30px',
                            float: 'right',
                            paddingBottom: '5px'
                          }}
                        />
                      </OverlayTrigger>
                    )}
                    {hasIncentiveId && (
                      <RequiredInput
                        label='Number of outers purchased'
                        model='.number_of_outers'
                        disabled={isAudit}
                      />
                    )}
                    {hasPostcodeplanObjectivesId && number_of_packs_solds && (
                      <div>
                        <Row>
                          <Col md={7}>
                            Number of packs sold
                          </Col>
                          <Col md={2}>
                            Shelf price
                          </Col>
                        </Row>
                        {category_number_of_packs_solds.map((numberOfPacksSold, index) => (
                          numberOfPacksSold.value !== null ? (
                            <Row key={index}>
                              <Col md={2} style={{ marginTop: 10 }}>
                                {numberOfPacksSold.label}
                              </Col>
                              <Col md={5}>
                                <TextInput
                                  model={`.category_number_of_packs_solds.${index}.value`}
                                  disabled
                                  zeroAllowed={packSoldsZeroAllowed}
                                />
                              </Col>
                              <Col md={5}>
                                <TextInput
                                  model={`.category_number_of_packs_solds.${index}.shelf-price`}
                                  disabled
                                />
                              </Col>
                            </Row>
                          ) : null
                        ))}
                        {number_of_packs_solds.map((numberOfPacksSold, index) => (
                          <Row key={index}>
                            <Col md={2} style={{ marginTop: 10 }}>
                              {numberOfPacksSold.label}
                            </Col>
                            <Col md={5}>
                              <TextInput
                                model={`.brand_number_of_packs_solds.${index}.value`}
                                disabled={packsSoldIsDisabled}
                                zeroAllowed={packSoldsZeroAllowed}
                              />
                            </Col>
                            <Col md={5}>
                              <TextInput
                                model={`.brand_number_of_packs_solds.${index}.shelf-price`}
                                disabled
                              />
                            </Col>
                          </Row>
                        ))}
                      </div>
                    )}
                  </Col>
                </Row>
                { !isAudit && (
                  <Row>
                    <Col md={12}>
                      <SearchableSelect
                        label='Wholesaler'
                        model='deep.admin_submission.wholesaler_id'
                        options={meta.wholesalers}
                        value={formData.wholesaler_id}
                        disabled={hasPostcodeplanObjectivesId}
                      />
                    </Col>
                  </Row>
                )}
                <Row>
                  {hasPostcodeplanObjectivesId && !isAudit && (
                    <Col md={12}>
                      <Select
                        label='Proof of purchase type'
                        model='.proof_type'
                        values={meta.proof_types}
                        disabled={hasPostcodeplanObjectivesId && !isDeclined}
                        required={!hasPostcodeplanObjectivesId}
                      />
                    </Col>
                  )}
                </Row>
                {!isAudit && (
                  <Row>
                    <Col md={12}>
                      <FileUpload
                        label='Proof of purchase'
                        model={'.proof_of_purchases'}
                        required
                        showFileNameInTextField={false}
                        onFileLoaded={this.handleFileUpload}
                        multi
                      />
                    </Col>
                    <Col md={12}>
                      <div style={{marginBottom: '20px'}}>{fileList}</div>
                    </Col>
                  </Row>
                )}
                <AuditAmount
                  onBlur={hasIncentiveId ? this.incentiveAuditAmount.bind(this) : this.postcodeplanAuditAmounts.bind(this)}
                  isAuditCompleted={audit_completed}
                  hasIncentiveId={hasIncentiveId}
                  hasPostcodeplanObjectivesId={hasPostcodeplanObjectivesId}
                  status={status}
                  auditAmounts={audit_amounts}
                  categoryAuditAmounts={category_audit_amounts}
                  categoryNumberOfPacksSold={category_number_of_packs_solds}
                  statusOptions={statusOptions}
                  isDeclined={isDeclined}
                  isAudit={isAudit}
                />
                {!isAudit && (
                  <Row>
                    <Col md={12}>
                      <FormGroup>
                        <ControlLabel>
                          Submission notes
                        </ControlLabel>
                        <Control.textarea
                          className='form-control'
                          label='Submission notes'
                          model='.notes'
                          disabled={isDeclined}
                        />
                      </FormGroup>
                    </Col>
                  </Row>
                )}
                {isAudit && (
                  <Row>
                    <Col md={12}>
                      <Select
                        label="Decline reason"
                        model="deep.admin_submission.decline_reason"
                        values={declineCommentOptions}
                        onChange={this.handleDeclineReasonSelectChange}
                      />
                    </Col>
                  </Row>
                )}
                <Row>
                  <Col md={12}>
                    <FormGroup>
                      <ControlLabel>
                        {isAudit ? 'Comments / Decline Reason' : 'Savi Submission Notes'}
                      </ControlLabel>
                      <Control.textarea
                        className="form-control savi-audit-text-area"
                        model="deep.admin_submission.savi_comment"
                        disabled={!isAudit}
                      />
                    </FormGroup>
                  </Col>
                </Row>
                {isAudit && (
                  <Row className="flex-row">
                    <Col className="audit-button">
                      <ArrowButton
                        arrow={false}
                        submit={false}
                        onClick={() => this.setState({ decline_confirm_dialog: true })}
                        disabled={!formData.decline_reason || !formValid || disable_buttons}
                      >
                        Decline
                      </ArrowButton>
                    </Col>
                    <Col className="audit-button">
                      <ArrowButton
                        arrow={false}
                        submit={false}
                        onClick={this.handleInternalEnquiryClick}
                        disabled={disable_buttons}
                      >
                        Internal Enquiry
                      </ArrowButton>
                    </Col>
                    {type === 'Price IT +' && (
                      <Col className="audit-button">
                        <ArrowButton
                          arrow={false}
                          submit={false}
                          onClick={this.handleRepEnquiryClick}
                          disabled={disable_buttons}
                        >
                          REP Enquiry
                        </ArrowButton>
                      </Col>
                    )}
                    <Col className="audit-button">
                      <ArrowButton
                        arrow={false}
                        submit={false}
                        onClick={this.handleITUKEnquiryClick}
                        disabled={disable_buttons}
                      >
                        ITUK Enquiry
                      </ArrowButton>
                    </Col>
                    <Col className="audit-button">
                      <ArrowButton
                        arrow={false}
                        submit={false}
                        onClick={this.handleValidateClick}
                        disabled={!formValid || disable_validate || !this.haveAuditAmounts() || disable_buttons}
                      >
                        Validate
                      </ArrowButton>
                    </Col>
                  </Row>
                )}
                {!isAudit && (
                  <Row>
                    <Col md={12}>
                      <ArrowButton
                        className='pull-right'
                        arrow={false}
                        permissions={{
                          action: 'update',
                          subjectClass: 'Submission',
                        }}
                        disabled={!formValid}
                        submit
                      >
                        save and finish
                      </ArrowButton>
                      <ArrowButton
                        className='pull-right'
                        arrow={false}
                        submit={false}
                        permissions={{
                          action: 'destroy',
                          subjectClass: 'Submission',
                        }}
                        onClick={() => this.handleRemove(submissionId)}
                      >
                        delete
                      </ArrowButton>
                    </Col>
                  </Row>
                )}
              </fieldset>
            </Col>
          </Form>
        </div>
        {removable && <RemoveSubmissionDialog onClose={this.handleConfirmRemove.bind(this)}/>}
        {this.state.decline_confirm_dialog && <DeclineSubmissionDialog onClose={this.handleConfirmDecline.bind(this)}/>}
        {popup && (
          <Modal
            container={this}
            show
          >
            <Modal.Body>
              {postcodeplan_audit_amount_warning && (
              <div>
                Are you sure this is the correct value? This is a high value submission.
                <br /><br />
                If you are sure then please <b>VALIDATE</b>, if not then please press the <b>INTERNAL ENQUIRY</b> button
              </div>
              )}
              {postcodeplan_audit_amount_disable_validate && (
              <div>
                This submission is over the maximum value that can be awarded.
                <br /><br />
                Please press the <b>INTERNAL ENQUIRY</b> button
              </div>
              )}
              {incentive_audit_amount_warning && (
              <div>
                Are you sure this is the correct value? This is over the maximum allowance for this incentive.
                <br /><br />
                If you are sure then please <b>VALIDATE</b>, if not then please press the <b>INTERNAL ENQUIRY</b> button
              </div>
              )}
              {receipt_id_uniqueness_warning && (
              <div>
                This receipt ID has already been saved against another submission.
                <br /><br />
                If you are sure this is correct then please <b>VALIDATE</b>, if not then please press the <b>INTERNAL ENQUIRY</b> button
              </div>
              )}
              <br/>
              <Button className="grey-ghost-btn" onClick={this.closePopup.bind(this)}>
                CLOSE
              </Button>
            </Modal.Body>
          </Modal>
        )}
      </div>
    );
  }
}

const mapStateToProps = state => ({
  formData: state.deep.admin_submission,
  formValid: state.deep.forms.admin_submission.$form.valid
});

export default connect(mapStateToProps)(AdminSubmissionForm);



// WEBPACK FOOTER //
// ./src/components/admin/submissions/form/submission-form.jsx